module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-500.24ebb2ab.eot";